import * as Sentry from '@sentry/react';

export const initializeSentry = (): ReturnType<typeof Sentry.init> => {
  return Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    enabled: ['production', 'staging'].includes(import.meta.env.MODE),
    sendDefaultPii: true
  });
};
